
import { create } from "apisauce";

export const api = create({
  baseURL: 'https://api-hcp.hurst.capital',
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

// export const apiProd = create({
//   baseURL: ".../",
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json"
//   }
// });
